import { axios } from '@sahinyazilim/sahinyazilim-components';
import { useAppDispatch, useAppSelector } from 'common/context/hooks';
import { AdminTablePaths } from 'common/model/AdminTablePaths';
import { OwnerEnv } from 'common/utils/env';
import { orderActions } from 'context/OrderSlice';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const POLLING_INTERVAL = 30000; // 30 saniye

export const NewOrderCheckManager = () => {
  const dispatch = useAppDispatch();
  const lastOrderId = useAppSelector((state) => state.order.lastOrderId);
  const { branchId } = useParams<{ branchId: string }>();

  const [isCheckingNewOrders, setIsCheckingNewOrders] = useState(false);

  const checkNewOrders = useCallback(async () => {
    if (isCheckingNewOrders) return;
    setIsCheckingNewOrders(true);

    try {
      const apiUrl = `${OwnerEnv.apiUrl}/${AdminTablePaths.ORDER}/check-new?last_order_id=${lastOrderId}&branch=${branchId}`;

      const response = await axios.get(apiUrl);
      if (response.status !== 200) return;

      const result = response.data;
      if (result.status === 'success' && result.data.hasNewOrders) {
        const currentCount = result.data.newOrderCount;
        const latestOrderId = result.data.latestOrderId;
        dispatch(orderActions.setNewOrderCount(currentCount));
        dispatch(orderActions.setLastOrderId(latestOrderId));
      }
    } catch (error) {
      // Hata durumunda sessizce devam et
    } finally {
      setIsCheckingNewOrders(false);
    }
  }, [isCheckingNewOrders, lastOrderId, branchId, dispatch]);

  useEffect(() => {
    const interval = setInterval(checkNewOrders, POLLING_INTERVAL);
    return () => {
      clearInterval(interval);
    };
  }, [checkNewOrders]);

  return null;
};
